export type TemplateChannel = "EMAIL" | "TEXT" | "NOTIFICATION" | "WHATSAPP";
export type TemplateFormat = "plainText" | "richText" | "html";
export type TemplateType = "default" | "custom";
export type TemplateStatus = "draft" | "published";

export interface Template {
  id: number;
  remoteUtilityId: number;
  templateName: string;
  templateAlias: string;
  version: number;
  isActive: boolean;
  templateType: number;
  templateTypeDisplay: string;
  description: string;
  tags: string[];
  content: Content;
  templateCategory: string;
  createdUserRemoteName: string;
  lastModifiedUserRemoteName: string;
  createdDate: string;
  lastModifiedDate: string;
  channelType: TemplateChannel;
  format: TemplateFormat;
  type: TemplateType;
  status: TemplateStatus;
  isDefault?: boolean;
  isDraft: boolean;
  usageCount: number;
}

export interface Content {
  body: string;
  subject: string;
}

export interface TemplateApiResponse {
  pageNumber: number;
  count: number;
  next: string | null;
  previous: string | null;
  results: Template[];
}

export interface CreateTemplateRequest {
  remoteUtilityId: string;
  templateName: string;
  channelType: string;
  templateCategory: string;
  content: {
    body: string;
    subject: string;
  };
  tags: string[];
}

export interface UpdateTemplateRequest {
  templateName: string;
  channelType: string;
  templateCategory: string;
  content: {
    body: string;
    subject: string;
  };
  tags: string[];
  isDraft: boolean;
}

export interface CreateTemplateResponse {
  id: number;
  message?: string;
}

export interface ChannelConstraint {
  channel: TemplateChannel;
  maxCharacters?: number;
  formats: TemplateFormat[];
  description: string;
}
export interface TemplateDetailDialogProps {
  template: Template;
  open: boolean;
  onClose: () => void;
  onUpdate: (template: Template) => void;
  isUpdating?: boolean;
  mode?: string;
}
export const CHANNEL_DISPLAY_NAMES: Record<TemplateChannel, string> = {
  EMAIL: "Email",
  TEXT: "SMS",
  NOTIFICATION: "In-App",
  WHATSAPP: "WhatsApp",
};
export const CHANNEL_CONSTRAINTS: Record<TemplateChannel, ChannelConstraint> = {
  EMAIL: {
    channel: "EMAIL",
    formats: ["plainText", "richText", "html"],
    description:
      "Support for Plain Text, Rich Text, and HTML formats. No character limit. Suitable for detailed messages.",
  },
  TEXT: {
    channel: "TEXT",
    maxCharacters: 160,
    formats: ["plainText"],
    description:
      "Plain Text only with 160 character limit (standard SMS length).",
  },
  NOTIFICATION: {
    channel: "NOTIFICATION",
    maxCharacters: 150,
    formats: ["plainText", "richText"],
    description:
      "Plain or Rich Text with 150 character limit. Concise and action-oriented.",
  },
  WHATSAPP: {
    channel: "WHATSAPP",
    maxCharacters: 1024,
    formats: ["plainText"],
    description:
      "Supports Plain Text and WhatsApp-compatible formatting with 1024 character limit.",
  },
};

export interface CloneTemplateResponse {
  message: string;
  templateId: number;
}
